if (!customElements.get("promis-card-purchase")) {
  customElements.define("promis-card-purchase", class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector("[data-card-variants]");
      if (!data) return;
      this.variants = JSON.parse(data.textContent);
      this.card = this.closest(".product-card");
      this.fields = Array.from(this.querySelectorAll("[data-option-index]"));
      this.button = this.querySelector('button[name="add"]');
      this.input = this.querySelector('input[name="id"]');
      this.quantity = this.querySelector('input[name="quantity"]');
      const selected = this.variants.find(v => String(v.id) === this.input?.value)
        || this.variants.find(v => v.available) || this.variants[0];
      this.selection = selected ? [...selected.options] : [];
      this.addEventListener("click", event => {
        const choice = event.target.closest("[data-option-value]");
        if (!choice || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.selection[Number(choice.closest("[data-option-index]").dataset.optionIndex)] = choice.dataset.optionValue;
        this.updateSelection();
      });
      this.addEventListener("change", event => {
        if (!event.target.matches("[data-option-select]")) return;
        this.selection[Number(event.target.closest("[data-option-index]").dataset.optionIndex)] = event.target.value;
        this.updateSelection();
      });
      this.ready = true;
      this.updateSelection();
    }
    updateSelection() {
      const variant = this.variants.find(v => v.options.every((value, index) => value === this.selection[index]));
      this.fields.forEach(field => {
        const index = Number(field.dataset.optionIndex);
        field.querySelectorAll("[data-option-value]").forEach(choice => {
          if (choice.dataset.optionValue === this.selection[index]) choice.setAttribute("aria-current", "true");
          else choice.removeAttribute("aria-current");
          const available = this.variants.some(v => v.available && v.options.every((value, i) => value === (i === index ? choice.dataset.optionValue : this.selection[i])));
          choice.classList.toggle("is-unavailable", !available);
        });
        const label = field.querySelector("[data-selected-label]");
        if (label) label.textContent = this.selection[index] || "";
      });
      if (this.input) { this.input.value = variant ? variant.id : ""; this.input.disabled = !variant; }
      if (this.quantity && variant) this.quantity.value = variant.quantity;
      if (this.button) {
        this.button.disabled = !variant?.available;
        this.button.querySelector("[data-add-label]").textContent = !variant ? this.dataset.unavailableLabel : variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
      }
      if (!variant || !this.card) return;
      this.card.querySelectorAll("[data-card-product-link], [data-configure-link]").forEach(link => { link.href = variant.url; });
      const price = this.card.querySelector("[data-card-price]");
      if (price) {
        price.replaceChildren();
        const current = document.createElement("span");
        current.textContent = variant.price;
        price.append(current);
        if (variant.onSale) { const compare = document.createElement("s"); compare.textContent = variant.compare; price.append(compare); }
        if (variant.unit) { const unit = document.createElement("small"); unit.textContent = variant.unit; price.append(unit); }
      }
      if (variant.image) {
        const image = this.card.querySelector(".product-card__image--main img");
        if (image) { image.src = variant.image; image.removeAttribute("srcset"); }
        this.card.classList.add("promis-card-variant-selected");
      }
    }
  });
}
